function isTravconExhibitor(code) {
    var result = false;
    if (code == "travcon2022exhibitor" || code == "travcon2023exhibitor") {
        result = true;
    }
    return result;
}
function isTravconExhibitor2022(code) {
    var result = false;
    if (code == "travcon2022exhibitor") {
        result = true;
    }
    return result;
}
function isTravconExhibitor2023(code) {
    var result = false;
    if (code == "travcon2023exhibitor") {
        result = true;
    }
    return result;
}

function isTravconAttendee(code) {
    var result = false;
    if (code == "travcon2022" || code == "travcon2023") {
        result = true;
    }
    return result;
}

function isMetro(code) {
    if (code == "metro2023convention") {
        return true;
    }
    else {
        return false;
    }
}
export default { isTravconExhibitor, isTravconAttendee, isMetro, isTravconExhibitor2022, isTravconExhibitor2023 }